// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"1944fdf8","484":"1d6389d1","498":"1adf5c36","509":"3699c0cf","551":"11af28b4","616":"b221d16b","842":"5b9c5c18","974":"e1cca8f4"}[chunkId] + ".chunk.js";
};